import { Add, Clear, DeleteOutlined, Save } from "@mui/icons-material";
import {
  Autocomplete,
  Box,
  CircularProgress,
  Divider,
  Grid,
  IconButton,
  Paper,
  TextField,
  Typography,
  createFilterOptions,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import NormalTable from "../../../../Component/NormalTable";
import { masterAPI } from "../../../Masters/dataConfig";
import { axiosPrivate } from "../../../../axios/axios";
import { color } from "../../../../StyleData/Config";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

const CreatePart = ({ workOrderId, handleCloseClick }) => {
  const [partData, setPartData] = useState([]);
  const [loadingParts, setLoadingParts] = useState(false);
  const [partSelect, setPartSelect] = useState("");
  const [srSelect, setSrSelect] = useState("");

  const [partItem, setPartItem] = useState({
    partId: null,
    stockRoomId: null,
    quantity: 0,
    stockRoom: [],
  });

  const [addedParts, setAddedParts] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setLoadingParts(true);
    const partLink = masterAPI["inventory"].getAll;
    await axiosPrivate
      .get(`${partLink}`)
      .then((res) => {
        const resData=res.data.result
        const uniqueParts = Array.from(
          new Map(resData.map(item => [item.partId, item])).values()
         );
        setPartData(uniqueParts || []);
      })
      .catch((e) => {
        setPartData([]);
        console.log(e, "Part WorkOrder");
      });
    setLoadingParts(false);
  };

  const handlePartChange = async (value) => {
    const srLink = masterAPI["selectList"].stockRoomByPart;
    await axiosPrivate
      .get(`${srLink}/${value.partId}`)
      .then((res) => {
        setPartItem({
          ...partItem,
          partId: value.partId,
          stockRoomId: null,
          stockRoom: Array.isArray(res.data) ? res.data : [],
        });
      })
      .catch(() => {
        setPartItem({
          ...partItem,
          partId: value.partId,
          stockRoom: [],
        });
      });
  };

  const handleStockRoomChange = (value) => {
    setPartItem({
      ...partItem,
      stockRoomId: value.value,
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPartItem({ ...partItem, [name]: value });
  };

  const handleAddPartList = () => {
    const partObj = partData.find((p) => p.partId === partItem.partId);
    const stockRoomObj = partItem.stockRoom?.find(
      (s) => s.value === partItem.stockRoomId
    );
    setAddedParts([
      ...addedParts,
      {
        ...partItem,
        quantity: Number(partItem.quantity),
        partCode: (partObj?.code ? partObj.code + " - " : "") + (partObj?.partName || ""),
        stockRoomName: stockRoomObj ? stockRoomObj.text : "",
      },
    ]);
    setPartItem({
      partId: null,
      stockRoomId: null,
      quantity: 0,
      stockRoom: [],
    });
    setPartSelect("");
    setSrSelect("");
  };

  const deleteAddedPart = (id) => {
    const updatedList = addedParts.filter((fil) => fil.partId !== id);
    setAddedParts(updatedList);
  };

  const handlePartSubmit = async () => {
    if (addedParts.length === 0) {
      toast.warning("Please add at least one part");
      return;
    }

    const wotlink = masterAPI["partsReservation"].create;
    const partsReservationId = "6acab941-c3e4-41ec-a738-53fd073a3144";

    const partsReservationItemsList = addedParts.map((item) => ({
      partsId: item.partId,
      quantity: item.quantity,
      stockRoomId: item.stockRoomId,
      stockRoomName: item.stockRoomName,
      partName: item.partName,
      partCode: item.partCode,
      // partsReservationId: partsReservationId,
    }));

    const payload = {
      // id: partsReservationId,
      workOrderId: workOrderId,
      partsReservationItemsList: partsReservationItemsList,
    };

    await axiosPrivate
      .post(`${wotlink}`, payload)
      .then((res) => {
        toast.success("Parts added successfully");
        handleCloseClick();
      })
      .catch((e) => {
        console.log(e, "createwotaskpart");
        toast.error("Error saving parts");
      });
  };

  const defaultFilterOptions = createFilterOptions();
  const filterOptions = (options, state) => {
    return defaultFilterOptions(options, state);
  };
  const CustomPaper = (props) => {
    return <Paper elevation={8} {...props} />;
  };

  const columns = [
    { Header: "Part", accessor: "partCode" },
    { Header: "Stock Room", accessor: "stockRoomName" },
    { Header: "Quantity", accessor: "quantity" },
    {
      Header: "Action",
      accessor: "partId",
      Cell: ({ cell }) => (
        <IconButton onClick={() => deleteAddedPart(cell.row.original.partId)}>
          <DeleteOutlined
            sx={{
              fontSize: color.masterEditDelButton,
              color: color.masterEditDelButtonColor,
            }}
          />
        </IconButton>
      ),
      disableFilters: true,
    },
  ];

  return (
    <Box sx={{ p: color.masterPageDialogPadding }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
        }}
      >
        <Typography
          sx={{
            color: color.masterDialogTitleColor,
            fontSize: color.masterDialogFontSize,
            // fontWeight: 500,
          }}
        >
          Add Part
        </Typography>
        <Box>
          <IconButton onClick={handlePartSubmit}>
            <Save sx={{ color: color.TableButtonColor }} />
          </IconButton>
          <IconButton onClick={handleCloseClick}>
            <Clear />
          </IconButton>
        </Box>
      </Box>
      <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }} />

      <Grid container spacing={"1rem"}>
        <Grid item xs={12}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Typography
              sx={{
                color: color.masterDialogTitleColor,
                fontSize: color.masterDialogFontSize,
              }}
            >
              Add Item
            </Typography>
            <IconButton
              sx={{ backgroundColor: color.TableButtonColor }}
              onClick={handleAddPartList}
              disabled={
                !partItem.partId || !partItem.stockRoomId || partItem.quantity <= 0
              }
            >
              <Add sx={{ color: "white" }} />
            </IconButton>
          </Box>
          <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }} />
        </Grid>
        <Grid container item xs={12} spacing={"1rem"}>
          <Grid item xs={12} md={4}>
            <Typography
              sx={{
                fontWeight: color.labelFontWeight,
                mb: color.labelmb,
                fontSize: color.labelFont,
                color: color.labelColor,
              }}
            >
              Part
            </Typography>
            <Autocomplete
              value={partData.find((p) => p.partId === partItem.partId) || null}
              inputValue={partSelect}
              fullWidth
              filterOptions={filterOptions}
              loading={loadingParts}
              options={partData}
              PaperComponent={CustomPaper}
              getOptionLabel={(option) =>
                (option.code ? option.code + " - " : "") + option.partName || option
              }
              isOptionEqualToValue={(option, value) =>
                option.partId === value?.partId
              }
              onChange={(event, value) => {
                if (value !== null) {
                  handlePartChange(value);
                  setPartSelect(
                    (value.code ? value.code + " - " : "") + value.partName
                  );
                } else {
                  setPartSelect("");
                  setPartItem({
                    partId: null,
                    stockRoomId: null,
                    quantity: 0,
                    stockRoom: [],
                  });
                  setSrSelect("");
                }
              }}
              onInputChange={(event, newInputValue, reason) => {
                if (reason !== 'reset') setPartSelect(newInputValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select Part"
                  variant="outlined"
                  size="small"
                  fullWidth
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {loadingParts ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography
              sx={{
                fontWeight: color.labelFontWeight,
                mb: color.labelmb,
                fontSize: color.labelFont,
                color: color.labelColor,
              }}
            >
              Stock Room
            </Typography>
            <Autocomplete
              value={
                partItem.stockRoom.find((s) => s.value === partItem.stockRoomId) ||
                null
              }
              inputValue={srSelect}
              fullWidth
              filterOptions={filterOptions}
              options={partItem.stockRoom}
              PaperComponent={CustomPaper}
              getOptionLabel={(option) => option.text || option}
              isOptionEqualToValue={(option, value) =>
                option.value === value?.value
              }
              disabled={!partItem.partId}
              onChange={(event, value) => {
                if (value !== null) {
                  handleStockRoomChange(value);
                  setSrSelect(value.text);
                } else {
                  setSrSelect("");
                  setPartItem({
                    ...partItem,
                    stockRoomId: null,
                  });
                }
              }}
              onInputChange={(event, newInputValue, reason) => {
                if (reason !== 'reset') setSrSelect(newInputValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder={
                    partItem.partId ? "Select Stock Room" : "Select Part First"
                  }
                  variant="outlined"
                  size="small"
                  fullWidth
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography
              sx={{
                fontWeight: color.labelFontWeight,
                mb: color.labelmb,
                fontSize: color.labelFont,
                color: color.labelColor,
              }}
            >
              Quantity
            </Typography>
            <TextField
              size={"small"}
              type="number"
              name="quantity"
              value={partItem.quantity}
              placeholder="Enter Quantity"
              fullWidth
              onChange={handleChange}
              sx={{
                ".MuiInputBase-input": {
                  "&::placeholder": {
                    opacity: 1,
                    color: color.placeholderColor,
                    fontSize: "13px",
                  },
                },
              }}
            />
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Typography
              sx={{
                color: color.masterDialogTitleColor,
                fontSize: color.masterDialogFontSize,
              }}
            >
              Part List
            </Typography>
          </Box>
          <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }} />
        </Grid>
        <Grid item xs={12}>
          <NormalTable data={addedParts} columns={columns} filt={true} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default CreatePart;

